import React, { useEffect, useState } from "react";
import { leaveRoom } from "../api";
import { roomSocket } from "../socket";

export default function GameRoom({ room, onLeave }) {
  const [players, setPlayers] = useState([]);
  const [status, setStatus] = useState("IDLE");
  const [countdown, setCountdown] = useState(null);

  useEffect(() => {
    const socket = roomSocket(room.type);

    socket.on("room_state", (data) => {
      setPlayers(data.players || []);
      setStatus(data.state || "IDLE");
      setCountdown(data.countdown ?? null);
    });

    socket.emit("subscribe_room", { roomType: room.type });

    return () => {
      socket.emit("unsubscribe_room", { roomType: room.type });
      socket.disconnect();
    };
  }, [room.type]);

  const handleExit = async () => {
    try {
      await leaveRoom(room.type);
    } catch (e) {
      console.warn("leaveRoom failed:", e);
    }
    onLeave();
  };

  return (
    <div className="screen">
      <button className="back-btn" onClick={handleExit}>
        ← Назад
      </button>

      <h1 style={{ marginTop: 10 }}>{room.title}</h1>

      <div className="room-status">
        <p>Статус: {status}</p>
        {countdown !== null && <p>⏳ До старта: {countdown}s</p>}
        <p>Игроков: {players.length}</p>
      </div>

      <div className="players-list">
        {players.map((p) => (
          <div className="player-item" key={p.id}>
            {p.name || `Игрок ${p.id}`}
          </div>
        ))}
      </div>
    </div>
  );
}

